import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

import { MoveToRootDirective } from '~app-client/core/directives';
import { ClientService, SessionService } from '~app-client/core/services';

@Component({
	selector: 'user-reactor',
	template: `@if (impersonating$ | async) {
		<div
			moveToRoot
			class="top-0 left-0 w-full h-full fixed pointer-events-none box-border border-[4px] border-solid border-warn z-max"
		></div>
	}`,
	styles: [':host { display: none; } '],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule, MoveToRootDirective],
})
export class UserReactorComponent implements OnInit {
	private readonly destroyRef = inject(DestroyRef);
	private readonly clientService = inject(ClientService);
	private readonly sessionService = inject(SessionService);

	public readonly impersonating$ = this.sessionService.user$.pipe(
		map((user) => user?.impersonating)
	);

	ngOnInit(): void {
		this.clientService.appFocused$
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(async (focused) => {
				if (focused) {
					if (this.sessionService.user) {
						await this.sessionService.ping();
					}
				}
			});
	}
}
